<template>
    <div class="telPage">
        <div class="bgBox"><img src="./../../../../assets/usercenter/usercenter-bg.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home/usercenter" tag="i"> <img src="./../../../../assets/home/back.jpg" alt=""> </router-link>
            <span>客服中心</span>
        </div>
        <div class="content">
            <div class="x-man"><img src="./../../../../assets/usercenter/x-man.png" alt=""></div>
            <div class="QR-code" @click="show"><img src="http://yy-repeat.oss-cn-beijing.aliyuncs.com/static/QQ-QRcode.jpg" alt=""></div>
            <p class="text">(二维码点击放大 长按保存)</p>
            <p class="text">客服QQ群</p>
            <div class="QQ" @click="openQQ">进入QQ</div>
        </div>
        <div class="mask" @click="hide" ref="mask">
            <div class="big"><img src="http://yy-repeat.oss-cn-beijing.aliyuncs.com/static/QQ-QRcode.jpg" alt=""></div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        show(){
            this.$refs.mask.style.display = "block";
        },
        hide(){
            this.$refs.mask.style.display = "none";
        },
        openQQ(){
            this.$bridge.callhandler('buildRelationShip', {
                rsUrl: 'mqqapi://card/show_pslcard?src_type=internal&version=1&uin=1106930286&card_type=group&source=qrcode',
                },(data) => {
                    window.location.href = "mqqapi://card/show_pslcard?src_type=internal&version=1&uin=1106930286&card_type=group&source=qrcode"
            })
            /*
            this.$bridge.callhandler('openLoApplic', {
                cn: "LSApplicationWorkspace",
                mn: "openApplicationWithBundleID:",
                bdid: "com.tencent.mqq"
                },(data) => {
            })*/
        }
    }
}
</script>

<style lang="scss" scoped>
   .mask{
       height:100%;
       width:100%;
       background:rgba(0,0,0,0.71);
       position:fixed;
        z-index: 1;
        top:0;
        display: none;
    }
    .big{
        width:3rem;
        height:3rem;
        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom: 0;
        margin:auto;
        z-index: 2;
    }
    .bgBox{
        width:100%;
        height:292px;
        position: absolute;
        z-index: -1;
        top:0;
    }
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .content{
        width:100%;
        display:flex;
        align-items: center;
        flex-direction: column;
        .x-man{
            width:1.05rem;
            height:1.55rem;
            padding:.25rem 0;
        }
        .QR-code{
            width:.90rem;
            height:.90rem;
        }
        .text{
            color:#4A4A4A;
            font-size: .12rem;
            padding:.10rem;
        }
        .QQ{
            width:1.80rem;
            height:.50rem;
            background:#000;
            text-align: center;
            line-height: .50rem;
            color:#fff;
            border-radius: .26rem;
            font-size: .16rem;
        }
    }
</style>

